document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('z-open-cart')) {
        urlParams.delete('z-open-cart');
        const newUrl = window.location.pathname + '?' + urlParams.toString();
        window.history.replaceState(null, '', newUrl);
        setTimeout(function () {
            window.wetheme.toggleRightDrawer('cart');
        }, 1000);
    }
});
window.addEventListener('pplrAppInitiated', function (e) {
    // check if pplr has loaded
    _SJ2[0] = "1"
    var prev_pplr_after_cart = pplr_after_cart;
    console.log("LOADED")
    window.pplr_after_cart = (cart, form) => {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('z-open-cart')) {
            urlParams.set('z-open-cart', '1');
            const newUrl = window.location.pathname + '?' + urlParams.toString();
            window.history.replaceState(null, '', newUrl);
        }
        prev_pplr_after_cart(cart, form)
    }
})